import React, { useContext, useState } from "react";
import { Row, Col, FormGroup, Label, Input } from "reactstrap";
import TranspaleStringToComponente from "../../../components/Dynamic/TranspaleStringToComponente";
import { DF_OT0086Context } from "../context";
import { useSelector } from "react-redux";
import BizinBackend from "../../../helpers/bizin_helper";
import useGetCsrfToken from "../../../Hooks/useGetCsrfToken";
import NotificationModal from "../../../components/Common/NotificationModal";
import { Checkbox } from "primereact/checkbox";

const diasSemana = [
  { id: "domingo", label: "Domingo" },
  { id: "segunda", label: "Segunda-feira" },
  { id: "terca", label: "Terça-feira" },
  { id: "quarta", label: "Quarta-feira" },
  { id: "quinta", label: "Quinta-feira" },
  { id: "sexta", label: "Sexta-feira" },
  { id: "sabado", label: "Sábado" },
];

function GridBody() {
  const { access_token, userProfile } = useSelector((state) => ({
    access_token: state.login.user.access_token,
    userProfile: state.login.profile,
  }));

  const csrfToken = useGetCsrfToken();

  const [preFilter, setPreFilter] = useState([]);

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const mapaDias = {
    domingo: 1,
    segunda: 2,
    terca: 3,
    quarta: 4,
    quinta: 5,
    sexta: 6,
    sabado: 7,
  };
  const [horarios, setHorarios] = useState({
    domingo: {
      disponivel: false,
      horaInicial: "",
      horaFinal: "",
    },
    segunda: {
      disponivel: false,
      horaInicial: "",
      horaFinal: "",
    },
    terca: {
      disponivel: false,
      horaInicial: "",
      horaFinal: "",
    },
    quarta: {
      disponivel: false,
      horaInicial: "",
      horaFinal: "",
    },
    quinta: {
      disponivel: false,
      horaInicial: "",
      horaFinal: "",
    },
    sexta: {
      disponivel: false,
      horaInicial: "",
      horaFinal: "",
    },
    sabado: {
      disponivel: false,
      horaInicial: "",
      horaFinal: "",
    },
  });

  const handleSave = () => {
    setShowConfirmModal(true);
  };

  const handleConfirm = async () => {
    try {
      const filtros = preFilter[0] || {};

      console.log("preFilter:", preFilter);
      console.log("filtros:", filtros);

      const idLocalDesembarque = Number(
        filtros.Filtro_ID_Local_Desembarque?.value,
      );

      const idEmpresaDestino = Number(filtros.Filtro_ID_Empresa_Destino?.value);

      if (!idLocalDesembarque) {
        alert("Selecione o Local de Desembarque.");
        return;
      }

      if (!idEmpresaDestino) {
        alert("Selecione a Empresa Destino.");
        return;
      }

      await BizinBackend.executeProcedure(
        {
          1: idLocalDesembarque,
          2: idEmpresaDestino,
        },
        "SRM_Horarios_Deletar",
        csrfToken,
        access_token,
      );

      for (const dia in horarios) {
        const horario = horarios[dia];

        if (!horario.disponivel) continue;

        await BizinBackend.executeProcedure(
          {
            1: idLocalDesembarque,
            2: mapaDias[dia],
            3: "S",
            4: horario.horaInicial.replace(":", ""),
            5: horario.horaFinal.replace(":", ""),
            6: idEmpresaDestino,
          },
          "SRM_Insere_Horarios",
          csrfToken,
          access_token,
        );
      }

      setShowConfirmModal(false);
      setShowSuccessModal(true);
    } catch (error) {
      setShowConfirmModal(false);
      setShowErrorModal(true);
    }
  };

  return (
    <>
      <div className="bg-white mb-3 card-content shadow-card p-4">
        <Row className="gx-3 mb-2">
          <Col lg={3}>
            <TranspaleStringToComponente
              elementId="ID_Empresa"
              elementProps={{
                value: "",
                type: "Combobox",
                title: "Empresa",
                id: "Filtro_ID_Empresa",
                procedure: "SRM_Agendamento_Get_Empresas",
                procedureParams: [userProfile?.ID_Usuario],
                formGroupClassName: "mb-4",
              }}
              preFilter={preFilter}
              onPreFilter={(filters) => {
                console.log("Local Desembarque:", filters);

                setPreFilter((state) => {
                  const novo = [{ ...state[0], ...filters }];

                  console.log("Novo preFilter:", novo);

                  return novo;
                });
              }}
            />
          </Col>

          <Col lg={3}>
            <TranspaleStringToComponente
              elementId="ID_Local_Entrega"
              elementProps={{
                value: "",
                type: "Combobox",
                title: "Local de Entrega",
                id: "Filtro_ID_Local_Entrega",
                procedure: "SRM_Agendamento_Local_Entrega",
                procedureParams: [
                  String(userProfile?.ID_Usuario),
                  "<#Filtro_ID_Empresa#>",
                ],
                alienated: ["Filtro_ID_Empresa"],
                formGroupClassName: "mb-4",
              }}
              preFilter={preFilter}
              onPreFilter={(filters) =>
                setPreFilter((state) => [{ ...state[0], ...filters }])
              }
            />
          </Col>

          <Col lg={3}>
            <TranspaleStringToComponente
              elementId="ID_Local_Desembarque"
              elementProps={{
                value: "",
                type: "Combobox",
                title: "Local de Desembarque",
                id: "Filtro_ID_Local_Desembarque",
                procedure: "SRM_Agendamento_Local_Desembarque",
                procedureParams: ["<#Filtro_ID_Local_Entrega#>"],
                alienated: ["Filtro_ID_Local_Entrega"],
                formGroupClassName: "mb-4",
              }}
              preFilter={preFilter}
              onPreFilter={(filters) =>
                setPreFilter((state) => [{ ...state[0], ...filters }])
              }
            />
          </Col>

          <Col lg={3}>
            <TranspaleStringToComponente
              elementId="ID_Empresa_Destino"
              elementProps={{
                value: "",
                type: "Combobox",
                title: "Empresa Destino",
                id: "Filtro_ID_Empresa_Destino",
                procedure: "CUA_GetMontaEmpresasOrigem",
                procedureParams: [String(userProfile?.ID_Usuario), 2],
                formGroupClassName: "mb-4",
              }}
              preFilter={preFilter}
              onPreFilter={(filters) =>
                setPreFilter((state) => [{ ...state[0], ...filters }])
              }
            />
          </Col>
        </Row>

        <h5 className="text-color-azul2 font-size-20 fw-semibold mb-3 mt-4">
          Informações do Local de Entrega
        </h5>

        <Row className="fw-normal mb-1">
          <Col lg={2}>Dia / Semana</Col>
          <Col lg={5}>Horário Início</Col>
          <Col lg={5}>Horário Término</Col>
        </Row>

        {diasSemana.map((dia) => (
          <Row className="align-items-center mb-2" key={dia.id}>
            <Col lg={2} className="pe-3">
              <div className="d-flex align-items-center gap-2">
                <Checkbox
                  inputId={dia.id}
                  checked={horarios[dia.id].disponivel}
                  onChange={(e) =>
                    setHorarios({
                      ...horarios,
                      [dia.id]: {
                        ...horarios[dia.id],
                        disponivel: e.checked,
                      },
                    })
                  }
                />

                <Label for={dia.id} className="mb-0 checkbox-label">
                  {dia.label}
                </Label>
              </div>
            </Col>

            <Col lg={5}>
              <TranspaleStringToComponente
                elementId={`horaInicial_${dia.id}`}
                elementProps={{
                  type: "Time",
                  id: `horaInicial_${dia.id}`,
                  value: horarios[dia.id].horaInicial,
                  placeholder: "00:00",
                  onChange: (e) =>
                    setHorarios({
                      ...horarios,
                      [dia.id]: {
                        ...horarios[dia.id],
                        horaInicial: e.target.value,
                      },
                    }),
                  formGroupClassName: "mb-0",
                }}
              />
            </Col>

            <Col lg={5}>
              <TranspaleStringToComponente
                elementId={`horaFinal_${dia.id}`}
                elementProps={{
                  type: "Time",
                  id: `horaFinal_${dia.id}`,
                  value: horarios[dia.id].horaFinal,
                  placeholder: "00:00",
                  onChange: (e) =>
                    setHorarios({
                      ...horarios,
                      [dia.id]: {
                        ...horarios[dia.id],
                        horaFinal: e.target.value,
                      },
                    }),
                  formGroupClassName: "mb-0",
                }}
              />
            </Col>
          </Row>
        ))}

        <div className="d-flex justify-content-end mt-4">
          <button
            className="btn btn-primary-dark text-white fw-semibold"
            onClick={handleSave}
          >
            Salvar
          </button>
        </div>
      </div>

      <NotificationModal
        isOpen={showConfirmModal}
        type="warning"
        titleCustom="Deseja alterar Horários Local de Desembarque?"
        message='Ao clicar em "Confirmar", os horários serão alterados.'
        confirmButton={true}
        onConfirm={handleConfirm}
        onClose={() => setShowConfirmModal(false)}
      />

      <NotificationModal
        isOpen={showSuccessModal}
        type="success"
        message="Horários Local de Desembarque alterados com sucesso!"
        onClose={() => setShowSuccessModal(false)}
      />

      <NotificationModal
        isOpen={showErrorModal}
        type="error"
        message="Não foi possível alterar os horários."
        onClose={() => setShowErrorModal(false)}
      />
    </>
  );
}

export default GridBody;
